"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.TitleBarAction = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectSpread2"));

var _jsxRuntime = require("react/jsx-runtime");

var _react = require("@fluentui/react");

var _Icon = require("@fluentui/react/lib/Icon");

var React = _interopRequireWildcard(require("react"));

var _stylingConstants = require("../styling/stylingConstants");

var _useResponsiveMode = require("../styling/useResponsiveMode");

var _TitleBarMarkers = require("./TitleBarMarkers");

var getClassNames = (0, _react.classNamesFunction)();
/**
 * An action icon button to be added to the right side of a title bar. Use this
 * as an immediate child of a `TitleBar` and it will be placed correctly.
 */

var TitleBarActionBase = function TitleBarActionBase(_ref) {
  var className = _ref.className,
      onClick = _ref.onClick,
      href = _ref.href,
      target = _ref.target,
      iconProps = _ref.iconProps,
      ariaLabel = _ref.ariaLabel,
      responsiveVisibilityMin = _ref.responsiveVisibilityMin,
      _styles = _ref.styles,
      children = _ref.children;
  var styles = typeof _styles === 'function' ? _styles({}) : _styles;
  var classes = getClassNames(styles);
  var responsiveMode = (0, _useResponsiveMode.useResponsiveMode)();
  var icon = onClick || href ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.IconButton, {
    className: (0, _react.css)('ms-TitleBar--action', className),
    styles: styles,
    iconProps: iconProps,
    onClick: onClick,
    href: href,
    target: target,
    ariaLabel: ariaLabel,
    children: children
  }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: classes.root,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, (0, _objectSpread2.default)({
      className: (0, _react.css)('ms-TitleBar--action', className),
      ariaLabel: ariaLabel,
      styles: {
        root: styles === null || styles === void 0 ? void 0 : styles.icon
      }
    }, iconProps))
  });
  return !responsiveVisibilityMin || responsiveMode >= responsiveVisibilityMin ? icon : null;
};

var TitleBarAction = (0, _react.styled)(TitleBarActionBase, {
  root: {
    boxSizing: 'border-box',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flex: '0 1 48px',
    height: 'auto',
    padding: "0 ".concat(_stylingConstants.gridUnit * 0.5, "px"),
    fontSize: _react.FontSizes.icon
  },
  icon: {
    margin: 0
  }
});
exports.TitleBarAction = TitleBarAction;

_TitleBarMarkers.TitleBarActionMarker.mark(TitleBarAction);